/* src/app/private/components/temp-student-profile/student-temp-profile-middle-screen/student-temp-profile-middle-screen.component.scss */
/*# sourceMappingURL=student-temp-profile-middle-screen.component.css.map */
